import { DEFAULT_FACE_URL } from '@panda/cache/src/user/define';
/**
* 对日期进行格式化，默认yyyy-MM-dd HH:mm:ss
* @param timestamp 要格式化的时间戳
* @param format 进行格式化的模式字符串
*     支持的模式字母有：
*     y:年,
*     M:年中的月份(1-12),
*     d:月份中的天(1-31),
*     H:小时(0-23),
*     m:分(0-59),
*     s:秒(0-59),
*     f:毫秒(0-999),
*     q:季度(1-4)
* @return String
*/
const formatTime = (timestamp: string | number | Date, format = 'yyyy-MM-dd HH:mm'): string => {
  if(!timestamp) {
    return '-';
  }

  const charString = (char: string, count: number): string => {
    let str = '';
    while (count--) {
      str += char;
    }
    return str;
  };

  const date = new Date(timestamp);

  // 没有分隔符的特殊处理

  const map: Map<string, number> = new Map();
  map.set('y', date.getFullYear());
  map.set('M', date.getMonth() + 1);
  map.set('d', date.getDate());
  map.set('H', date.getHours());
  map.set('m', date.getMinutes());
  map.set('s', date.getSeconds());
  map.set('q', Math.floor((date.getMonth() + 3) / 3));
  map.set('f', date.getMilliseconds());

  const reg = 'yMdHmsqf';
  let all = '';
  let str = '';
  for (let i = 0, n = 0; i < reg.length; i++) {
    n = format.indexOf(reg[i]);
    if (n < 0) { continue; }
    all = '';
    for (; n < format.length; n++) {
      if (format[n] != reg[i]) {
        break;
      }
      all += reg[i];
    }
    if (all.length > 0) {
      if (all.length == String(map.get(reg[i])).length) {
        str = String(map.get(reg[i]));
      } else if (all.length > String(map.get(reg[i])).length) {
        if (reg[i] == 'f') {
          str = String(map.get(reg[i])) + charString('0', all.length - String(map.get(reg[i])).length);
        } else {
          str = charString('0', all.length - String(map.get(reg[i])).length) + String(map.get(reg[i]));
        }
      } else {
        switch (reg[i]) {
          case 'y': str = String(map.get(reg[i])).substr(String(map.get(reg[i])).length - all.length); break;
          case 'f': str = String(map.get(reg[i])).substr(0, all.length); break;
          default: str = String(map.get(reg[i])); break;
        }
      }
      format = format.replace(all, str);
    }
  }
  return format;
};

/**
* 对日期进行格式化，仅限格式yyyy-MM-dd HH:mm:ss 和 yyyy-mm-dd
* @param timestamp 要格式化的时间戳
* @param currentTime 当前时间
*     如果日期年份为今年，则隐藏年份
* @return String
*/
const formatTimeHideCurrentYear = (
  timestamp: string | number | Date,
  currentTime?: string | number | Date,
  format = 'yyyy-MM-dd HH:mm',
): string => {
  if (!timestamp) {
    return '';
  }
  let timeAfterFormat = formatTime(timestamp, format);
  const theYear = new Date(currentTime || new Date()).getFullYear();
  if (timeAfterFormat.indexOf(theYear.toString()) === 0) {
    timeAfterFormat = timeAfterFormat.substring(5);
  }
  return timeAfterFormat;
};

const formatLastTimeWithinAnHour = (lastTime: number): string => {
  if (!lastTime) {
    return '00:00';
  }

  let minutes;
  let seconds;
  if (lastTime > 60 && lastTime <= 3600) {
    minutes = Math.floor(lastTime / 60);
    seconds = Math.round(lastTime - (60 * minutes)).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  } if (lastTime > 0 && lastTime <= 60) {
    seconds = Math.round(lastTime).toString().padStart(2, '0');
    return `00:${seconds}`;
  }
  return '00:00';
};

/**
 * 12 => 12.00
 * 1.111 => 1.11
 * @param value
 * @param unit 默认传入以分为单位
 */
function formatPrice(value: string, unit = 100): string {
  const valueNum = parseFloat(value) / unit;
  return Number.isInteger(valueNum) ? `${valueNum}` : valueNum.toFixed(2);
}

function formatName(value: string) {
  return value || '无名氏';
}

function formatSex(value: number) {
  if (value === 1) {
    return '男';
  }
  if (value === 2) {
    return '女';
  }
  return '';
}

const adjustImageSize = (url: string, width = 72, height = 72) => {
  const newUrl = url.indexOf('?') > -1
    ? url.substring(0, url.indexOf('?'))
    : url;
  return `${newUrl}?imageView&thumbnail=${width}y${height}&quality=100`;
};

function formatHeadImg(url?: string, width = 90, height = 90) {
  const newUrl = url || DEFAULT_FACE_URL;
  return adjustImageSize(newUrl, width, height);
}

export {
  formatTime,
  formatPrice,
  formatName,
  formatSex,
  formatTimeHideCurrentYear,
  formatLastTimeWithinAnHour,
  formatHeadImg,
  adjustImageSize,
};
